var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatar3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_50_Kids_Icons-22",
    "data-name": "50_Kids_Icons-22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_996",
    "data-name": "Path 996",
    d: "M0,40A40,40,0,1,1,40,80,40,40,0,0,1,0,40Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_994",
    "data-name": "Path 994",
    d: "M80,40A40,40,0,1,1,40,0,40,40,0,0,1,80,40Z",
    fill: "#9ec853"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4406",
    "data-name": "Group 4406"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4392",
    "data-name": "Group 4392",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_995",
    "data-name": "Path 995",
    d: "M172.188,131.2H130V106.978a21.094,21.094,0,0,1,21.094-21.094h0a21.094,21.094,0,0,1,21.094,21.094Z",
    transform: "translate(-109.688 -72.465)",
    fill: "#2b1d2b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4393",
    "data-name": "Group 4393",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_997",
    "data-name": "Path 997",
    d: "M159.79,246.493c1.025,2.428.467,4.787-1.247,5.27s-3.933-1.093-4.958-3.521-.467-4.787,1.247-5.27S158.765,244.065,159.79,246.493Z",
    transform: "translate(-129.154 -204.934)",
    fill: "#e38a5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_998",
    "data-name": "Path 998",
    d: "M326.844,246.492c-1.025,2.428-.467,4.787,1.247,5.27s3.933-1.093,4.958-3.521.467-4.787-1.247-5.27S327.869,244.065,326.844,246.492Z",
    transform: "translate(-275.341 -204.934)",
    fill: "#e38a5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4394",
    "data-name": "Group 4394",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_44",
    "data-name": "Ellipse 44",
    cx: 17.969,
    cy: 16.449,
    rx: 17.969,
    ry: 16.449,
    transform: "translate(23.1 13.485)",
    fill: "#ffc34a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4395",
    "data-name": "Group 4395",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1001",
    "data-name": "Path 1001",
    d: "M135.242,412.258l-.008-.132c0-8-2.995-15.753-6.652-17.229l-15.575-6.275a20.633,20.633,0,0,0-13.3-.017l-15.8,6.312c-3.66,1.465-6.655,9.208-6.655,17.209l-.008.132Z",
    transform: "translate(-65.172 -326.964)",
    fill: "#e38a5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4396",
    "data-name": "Group 4396",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1003",
    "data-name": "Path 1003",
    d: "M233.822,277.007a6.219,6.219,0,0,1-6.219,6.219h-.754a6.219,6.219,0,0,1-6.219-6.219V260.989a6.219,6.219,0,0,1,6.219-6.219h.754a6.219,6.219,0,0,1,6.219,6.219Z",
    transform: "translate(-186.157 -214.962)",
    fill: "#e38a5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4398",
    "data-name": "Group 4398",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4397",
    "data-name": "Group 4397",
    transform: "translate(28.125 18.107)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1005",
    "data-name": "Path 1005",
    d: "M206.767,143.36a10.422,10.422,0,0,1-10.423,10.422h-5.923A10.422,10.422,0,0,1,180,143.36V126.306a10.422,10.422,0,0,1,10.422-10.422h5.923a10.422,10.422,0,0,1,10.423,10.422Z",
    transform: "translate(-180 -115.884)",
    fill: "#f5b68c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4399",
    "data-name": "Group 4399",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_45",
    "data-name": "Ellipse 45",
    cx: 1.548,
    cy: 1.548,
    r: 1.548,
    transform: "translate(34.39 41.491)",
    fill: "#572020"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_46",
    "data-name": "Ellipse 46",
    cx: 1.548,
    cy: 1.548,
    r: 1.548,
    transform: "translate(44.653 41.491)",
    fill: "#572020"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4400",
    "data-name": "Group 4400",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1008",
    "data-name": "Path 1008",
    d: "M178,102.076c-8.677,0-15.711,7.624-15.711,17.029a18.05,18.05,0,0,0,2.13,8.566l1.561-13.238h24.037l1.564,13.239a18.051,18.051,0,0,0,2.13-8.566C193.716,109.7,186.682,102.076,178,102.076Z",
    transform: "translate(-136.936 -86.127)",
    fill: "#2b1d2b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4401",
    "data-name": "Group 4401",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1010",
    "data-name": "Path 1010",
    d: "M251.273,279.542a2.384,2.384,0,0,1-4.653.538,2.526,2.526,0,0,0-.114.71,2.553,2.553,0,1,0,5.105,0A2.516,2.516,0,0,0,251.273,279.542Z",
    transform: "translate(-207.989 -235.864)",
    fill: "#e38a5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4402",
    "data-name": "Group 4402",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1012",
    "data-name": "Path 1012",
    d: "M135.233,425.067c0-8-2.995-15.753-6.652-17.229L116.2,402.849a10.937,10.937,0,0,1-19.889.053l-12.4,4.956c-3.66,1.465-6.655,9.208-6.655,17.209l-.008.132h58Z",
    transform: "translate(-65.172 -339.904)",
    fill: "#fcf2c8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4403",
    "data-name": "Group 4403",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1014",
    "data-name": "Path 1014",
    d: "M185.661,120.554l-1.17-3.975L168,128.586v8.136l10.3-2.551C184.153,132.721,187.448,126.625,185.661,120.554Z",
    transform: "translate(-141.75 -98.364)",
    fill: "#2b1d2b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4404",
    "data-name": "Group 4404",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1016",
    "data-name": "Path 1016",
    d: "M292.088,157.8a32.017,32.017,0,0,0-2.7-11.509,7.032,7.032,0,1,0,2.7,11.509Z",
    transform: "translate(-236.25 -123.09)",
    fill: "#2b1d2b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4405",
    "data-name": "Group 4405",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1018",
    "data-name": "Path 1018",
    d: "M245.7,317.587a.7.7,0,0,1-.7.7h-6.8a.7.7,0,0,1-.7-.7h0a.7.7,0,0,1,.7-.7H245a.7.7,0,0,1,.7.7Z",
    transform: "translate(-200.391 -267.371)",
    fill: "#c96a46"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar3);
export default __webpack_public_path__ + "static/media/avatar3.768b49c60608b5cfbb5c4c8aff4bca87.svg";
export { ForwardRef as ReactComponent };